import { withoutTrailingSlash, withLeadingSlash } from '@studiometa/js-toolkit/utils';

/**
 * Execute a request against the WordPress REST API, but localized with
 * WeGlot current language.
 * @param {string|URL}  path      The REST API path.
 * @param {RequestInit} [options] Options for the underlying fetch request.
 * @returns {Promise<any>}
 */
export async function wpLocalizedApi(path, options) {
  const baseUrl = new URL(window.__WEGLOT_BASE_URL__ ?? window.location.origin);
  const url = new URL(path, baseUrl);

  if (!url.pathname.startsWith(baseUrl.pathname)) {
    url.pathname = `${withoutTrailingSlash(baseUrl.pathname)}${withLeadingSlash(url.pathname)}`;
  }

  return fetch(url, options).then((response) => response.json());
}
